import styled from 'styled-components';
import {Divider, Select} from 'antd';

const StyledAvatarSelect = styled(Select)`
  &.ant-select-single.ant-select-lg {
    width: 32px;

    .ant-select-selector {
      border: none !important;
      box-shadow: none !important;
      height: 32px;
      padding: 0;

      .ant-select-selection-item {
        line-height: 32px;

        .ant-space-item {
          &:nth-child(2) {
            display: none;
          }
        }
      }
    }
  }
`;

const StyledAvatarSelectDropdownDivider = styled(Divider)`
  margin: 4px 0 8px 0;
`;

const StyledAvatarSelectDropdownHeader = styled.div`
  padding: 4px;
`;

export {
  StyledAvatarSelect,
  StyledAvatarSelectDropdownDivider,
  StyledAvatarSelectDropdownHeader
};
